var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOut = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 72 72",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "out-a",
    d: "M41,6 L10,6 C8.8954305,6 8,6.8954305 8,8 L8,64 C8,65.1045695 8.8954305,66 10,66 L41,66 L41,6 Z M41,13 L41,59 L15,59 L15,13 L41,13 Z M50.2647746,21.5814976 L63.4416307,34.5863568 C63.8138769,34.9342368 64,35.3698996 64,35.8933452 C64,36.4167908 63.8138769,36.8524535 63.4416307,37.2003335 L50.2647746,50.2051928 C49.6959736,50.8055838 49.009679,50.9410511 48.2058908,50.6115946 C47.4416331,50.2821382 47.0595043,49.7110081 47.0595043,48.8982044 L47.0595043,41.467553 L33.8826482,41.467553 C33.373143,41.467553 32.9317184,41.2838593 32.5583741,40.9164721 C32.1850299,40.5490848 31.9989068,40.113422 32.0000048,39.6094837 L32.0000048,32.1788323 C32.0000048,31.6759777 32.1861279,31.2403149 32.5583741,30.8718439 C32.9306203,30.5033729 33.372045,30.3196792 33.8826482,30.320763 L47.0595043,30.320763 L47.0595043,22.8901115 C47.0595043,22.0773078 47.4416331,21.5061778 48.2058908,21.1767213 C49.009679,20.8456393 49.6959736,20.9811066 50.2647746,21.5814976 Z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#out-a"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOut);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/out.acefc2f5c8030b0a9445dad80e4c94db.svg";